import { AudioLines, ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Privacy Policy", href: "/?view=coming-soon", testid: "footer-link-privacy" },
  { label: "Terms of Service", href: "/?view=coming-soon", testid: "footer-link-terms" },
  { label: "Support", href: "/?view=coming-soon", testid: "footer-link-support" },
  { label: "Accessibility", href: "/?view=coming-soon", testid: "footer-link-accessibility" },
  { label: "Contact", href: "/?view=coming-soon", testid: "footer-link-contact" },
];

export default function Footer() {
  return (
    <footer className="border-t border-[#00D4FF]/12 bg-[#050F1F]" aria-label="Site footer">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div>
            <a href="/" className="flex items-center gap-3" data-testid="footer-logo-link">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-[#2563EB] to-[#00D4FF]">
                <AudioLines className="h-5 w-5 text-white" strokeWidth={2.4} aria-hidden="true" />
              </span>
              <span className="font-display text-lg font-bold text-white">
                VoiceLens <span className="text-[#00D4FF]">AI</span>
              </span>
            </a>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-400">
              Let AI Read the World to You. Read Without Limits.
            </p>
          </div>

          <nav aria-label="Footer navigation">
            <ul className="flex flex-wrap gap-x-8 gap-y-3">
              {LINKS.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    data-testid={l.testid}
                    className="group inline-flex items-center gap-1 text-sm font-medium text-slate-300 transition-colors duration-200 hover:text-[#00D4FF]"
                  >
                    {l.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity duration-200 group-hover:opacity-100" aria-hidden="true" />
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-slate-500/20 pt-7 text-sm text-slate-500 sm:flex-row sm:items-center">
          <p data-testid="footer-copyright">Copyright © {new Date().getFullYear()} Next Wave Essentials LLC. All rights reserved.</p>
          <p>Built for independence.</p>
        </div>
      </div>
    </footer>
  );
}
